module.exports = __webpack_public_path__ + "static/media/lowresportfolio-1.f77ac43f.jpg";